import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { Link } from "react-router-dom";


const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`;
const Linkz = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`;
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoText>Bradenton Cash For Gold</LogoText>
          </LogoContainer>
          <LinksContainer>
            <Link to="/"><Linkz>Home</Linkz></Link>
            <Link to="/about-us"><Linkz>About</Linkz></Link>
            <Link to="/what-we-buy"><Linkz>What We Buy</Linkz></Link>
            <Link to="/areas-we-serve"><Linkz>Areas We Serve</Linkz></Link>
            <Link to="/testimonials"><Linkz>Testimonials</Linkz></Link>
            <Link to="/contact"><Linkz>Contact</Linkz></Link>
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink target="_blank" href="https://www.facebook.com/Bradenton-Cash-for-Gold-183123745413853/">
              <FacebookIcon />
            </SocialLink>
          </SocialLinksContainer>
          <CopyrightText>
            Copyright &copy; {1900 + new Date().getYear()} Bradenton Cash For
            Gold. All Rights Reserved.
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
